var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "match-badge"
    }
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    attrs: {
      "id": "icon"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.iconSrc,
      "alt": "Automation icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "found"
  }, [_c('span', {
    staticClass: "finder",
    attrs: {
      "data-test": "finder"
    }
  }, [_vm._v("Found by " + _vm._s(_vm.finder))]), _vm._v(" "), _c('span', {
    staticClass: "result",
    attrs: {
      "data-test": "result"
    }
  }, [_vm._v(_vm._s(_vm.resultValue))])])]), _vm._v(" "), _c('div', {
    staticClass: "action",
    on: {
      "click": _vm.handleActionClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.penSrc,
      "alt": "Change icon"
    }
  }), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.actionType))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }